import { TableBlockProps } from '../../blocks/TableBlock';
import { DataServiceEditorSubNavProps } from '../../organisms/DataServiceEditorSubNav';
import { TableTabNavProps } from '../../organisms/TableTabNav';


type DatabasePageInternalProps = {
  dataServiceEditorSubNav?: DataServiceEditorSubNavProps;
  tableTabNav?: TableTabNavProps;
  tableBlock?: TableBlockProps;
};

type DatabasePagePropsValues = {
  '': DatabasePageInternalProps;
};

const propValues: DatabasePagePropsValues = {
  '': {
    dataServiceEditorSubNav: {
    },
    tableTabNav: {
      state: 'NoTableOverflow',
    },
    tableBlock: {
    },
  },
};

const getProps = (type: string): DatabasePageInternalProps => {
  const values: DatabasePageInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
